import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import Layout from "../layouts/Layout";
import Profile from "../modules/Profile";
import Wishlist from "../modules/Wishlist";
import Login from "../modules/auth/Login";
import Register from "../modules/auth/Register";
import Cart from "../modules/Cart";
import Checkout from "../modules/Checkout";
import Orders from "../modules/Orders";
import Home from "../modules/Home";
import ProductDetail from "../modules/product/ProductDetail";
import ProductList from "../modules/product/ProductList";
import Categories from "../modules/product/Categories";

import AboutUs from "../modules/pages/AboutUs";
import ContactUs from "../modules/pages/ContactUs";
import Faq from "../modules/pages/Faq";
import PrivacyPolicy from "../modules/pages/PrivacyPolicy";
import ReturnPolicy from "../modules/pages/ReturnPolicy";
import ShippingPolicy from "../modules/pages/ShippingPolicy";
import Terms from "../modules/pages/Terms";

function NotFoundPage() {
  return (
    <main className="page-shell content-page">
      <div className="empty-state">
        <span className="empty-state__icon">✳</span>
        <h2>This page wandered off.</h2>
        <p>Let's get you back to the good finds.</p>
        <Link className="button button--primary" to="/shop">Browse the store</Link>
      </div>
    </main>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="shop" element={<ProductList />} />
        <Route path="categories" element={<Categories />} />
        <Route path="product/:slug/:productCode" element={<ProductDetail />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="orders" element={<Orders />} />
        <Route path="profile" element={<Profile />} />
        <Route path="wishlist" element={<Wishlist />} />

        {/* New Pages */}
        <Route path="about" element={<AboutUs />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="shipping-policy" element={<ShippingPolicy />} />
        <Route path="return-policy" element={<ReturnPolicy />} />
        <Route path="faq" element={<Faq />} />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
